<div class="tsd_container">
  <mat-card>
    <!-- <mat-card-content style="text-align: end;">
    <mat-hint style="color: red;">{{showStatus}} </mat-hint>
    <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked"
    [ngModelOptions]="{standalone: true}" *ngIf="showDeactivateToggle && data.id">Deactivate Vessel</mat-slide-toggle>
    <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked"
    [ngModelOptions]="{standalone: true}"*ngIf="showReactivateToggle && data.id">Reactivate Vessel</mat-slide-toggle>
  </mat-card-content> -->
  <form [formGroup]="documentMasterForm">
    <mat-card-content>
      <h4>Add Document</h4>
      <mat-form-field class="mat-width">
        <mat-label>Document Code</mat-label>
        <input matInput placeholder="Document Code" formControlName="code" autocomplete="off" required>
        @if (code.touched && code.invalid && code.hasError('required')) {
          <mat-error>Document Code is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="mat-width">
        <mat-label>Document Name</mat-label>
        <input matInput placeholder="Document Name" formControlName="name" autocomplete="off" required>
        @if (name.touched && name.invalid && name.hasError('required')) {
          <mat-error>Document Name is required</mat-error>
        }
      </mat-form-field>
      <mat-card-actions>
        <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
        @if (id?.value || !id?.value) {
          <button mat-button color="primary" (click)="onSave()">SAVE</button>
        }
      </mat-card-actions>
    </mat-card-content>
  </form>
</mat-card>
</div>
